<template>
  <div class="auth-wrap">
    <div class="auth-card">
      <div class="auth-logo">Mobi<span>FIX</span> PRO</div>
      <h1 class="auth-title">Вхід в акаунт</h1>
      <p class="auth-sub">Введіть номер телефону і пароль</p>

      <div v-if="error" class="auth-error">{{ error }}</div>

      <form @submit.prevent="handleLogin" class="auth-form">
        <div class="auth-field">
          <label class="auth-label">Номер телефону</label>
          <input v-model="form.phone" type="tel" required class="auth-input" placeholder="+38 (0XX) XXX-XX-XX" />
        </div>
        <div class="auth-field">
          <label class="auth-label">Пароль</label>
          <input v-model="form.password" type="password" required class="auth-input" placeholder="Ваш пароль" />
          <div class="auth-forgot"><a href="#" class="auth-forgot-link">Забули пароль?</a></div>
        </div>
        <button type="submit" :disabled="loading" class="auth-btn">
          <span class="auth-spin" v-if="loading"></span>
          {{ loading ? 'Входимо...' : 'Увійти' }}
        </button>
      </form>

      <div class="auth-divider"><span>або</span></div>
      <div class="auth-switch">
        Немає акаунту? <router-link to="/register" class="auth-switch-link">Зареєструватись</router-link>
      </div>
    </div>

    <div class="auth-side">
      <div class="auth-side-content">
        <div class="auth-side-icon">📱</div>
        <h2>MobiFIX PRO</h2>
        <p>Ваш особистий кабінет для управління замовленнями та відстеження ремонту в реальному часі</p>
        <div class="auth-features">
          <div class="auth-feat"><span>✓</span> Статус ремонту онлайн</div>
          <div class="auth-feat"><span>✓</span> Історія всіх замовлень</div>
          <div class="auth-feat"><span>✓</span> Чат з майстром</div>
          <div class="auth-feat"><span>✓</span> Бонуси та кешбек</div>
          <div class="auth-feat"><span>✓</span> Реферальна програма</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter();
    const authStore = useAuthStore();
    const form = ref({ phone: '', password: '' });
    const loading = ref(false);
    const error = ref('');

    const handleLogin = async () => {
      error.value = '';
      if (!form.value.phone || !form.value.password) { error.value = 'Введіть телефон і пароль'; return; }
      loading.value = true;
      try {
        await authStore.login(form.value.phone, form.value.password);
        router.push('/');
      } catch (err) { error.value = err || 'Помилка входу. Перевірте дані'; }
      finally { loading.value = false; }
    };

    return { form, loading, error, handleLogin };
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }
.auth-wrap { display: grid; grid-template-columns: 1fr 1fr; min-height: calc(100vh - 60px); margin: -2.5rem -2rem; }
.auth-card { display: flex; flex-direction: column; justify-content: center; padding: 3rem 3rem; background: #fff; }
.auth-logo { font-size: 20px; font-weight: 800; color: #534ab7; margin-bottom: 2rem; }
.auth-logo span { color: #1d9e75; }
.auth-title { font-size: 26px; font-weight: 800; color: #26215c; margin-bottom: 6px; }
.auth-sub { font-size: 14px; color: #666; margin-bottom: 2rem; }
.auth-error { background: #ffeaea; border: 1px solid #f5c6c6; color: #c0392b; border-radius: 10px; padding: 12px 16px; font-size: 14px; margin-bottom: 1.25rem; }
.auth-form { display: flex; flex-direction: column; gap: 1.25rem; }
.auth-field { display: flex; flex-direction: column; gap: 6px; }
.auth-label { font-size: 13px; font-weight: 700; color: #444; }
.auth-input { background: #f4f3ff; border: 1.5px solid #e0dff8; border-radius: 10px; padding: 12px 16px; color: #26215c; font-size: 15px; outline: none; transition: border-color 0.15s; }
.auth-input:focus { border-color: #534ab7; background: #fff; }
.auth-forgot { text-align: right; margin-top: 4px; }
.auth-forgot-link { font-size: 12px; color: #534ab7; text-decoration: none; }
.auth-btn { background: linear-gradient(135deg, #534ab7, #7f77dd); color: #fff; border: none; padding: 13px; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 4px 20px rgba(83,74,183,0.3); transition: transform 0.2s; margin-top: 0.5rem; }
.auth-btn:hover:not(:disabled) { transform: translateY(-2px); }
.auth-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.auth-spin { width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.4); border-top-color: #fff; border-radius: 50%; animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.auth-divider { text-align: center; position: relative; margin: 1.5rem 0; }
.auth-divider::before { content: ''; position: absolute; top: 50%; left: 0; right: 0; height: 1px; background: #e0dff8; }
.auth-divider span { background: #fff; padding: 0 12px; font-size: 13px; color: #bbb; position: relative; }
.auth-switch { text-align: center; font-size: 14px; color: #666; }
.auth-switch-link { color: #534ab7; font-weight: 700; text-decoration: none; }
.auth-switch-link:hover { text-decoration: underline; }
.auth-side { background: linear-gradient(135deg, #26215c, #1a3a2a); display: flex; align-items: center; justify-content: center; padding: 3rem; }
.auth-side-content { color: #fff; max-width: 320px; }
.auth-side-icon { font-size: 52px; margin-bottom: 1.5rem; }
.auth-side-content h2 { font-size: 28px; font-weight: 800; margin-bottom: 1rem; }
.auth-side-content p { font-size: 15px; color: rgba(255,255,255,0.65); line-height: 1.7; margin-bottom: 2rem; }
.auth-features { display: flex; flex-direction: column; gap: 12px; }
.auth-feat { display: flex; align-items: center; gap: 10px; font-size: 14px; color: rgba(255,255,255,0.8); }
.auth-feat span { width: 22px; height: 22px; background: #1d9e75; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; flex-shrink: 0; }
@media (max-width: 700px) {
  .auth-wrap { grid-template-columns: 1fr; }
  .auth-side { display: none; }
  .auth-card { padding: 2rem 1.5rem; margin: 0; }
}
</style>
